/**
 * @generated SignedSource<<e36750958e24eabb63e69fb6d3ba7551>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarsAdminListQuery$variables = Record<PropertyKey, never>;
export type CalendarsAdminListQuery$data = {
  readonly store: {
    readonly archivedCalendars: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly calendars: ReadonlyArray<{
      readonly __typename: "StoreCalendar";
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
    readonly id: string;
  };
};
export type CalendarsAdminListQuery = {
  response: CalendarsAdminListQuery$data;
  variables: CalendarsAdminListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Store",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreCalendar",
        "kind": "LinkedField",
        "name": "calendars",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreCalendar",
        "kind": "LinkedField",
        "name": "archivedCalendars",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarsAdminListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CalendarsAdminListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3872a67310bae1551cb3a38c3927d345",
    "id": null,
    "metadata": {},
    "name": "CalendarsAdminListQuery",
    "operationKind": "query",
    "text": "query CalendarsAdminListQuery {\n  store {\n    id\n    calendars {\n      __typename\n      id\n      title\n      color\n    }\n    archivedCalendars {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1990f1f4463148921be7a76a134dc5a7";

export default node;
